import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="thinking-message"
// Shows typing dots initially, then after a delay replaces them with
// rotating "thinking" messages that cycle every delay interval.
export default class extends Controller {
  static targets = ["dots", "message"]
  static values = { delay: { type: Number, default: 2500 } }

  static MESSAGES = [
    "Thinking...",
    "Working on it...",
    "Cogitating...",
    "Reticulating splines...",
    "Pondering...",
    "Almost there..."
  ]

  connect() {
    this._messageIndex = 0
    this._shuffled = this._shuffleMessages()

    this.timer = setTimeout(() => {
      this._showMessage()
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    clearInterval(this.interval)
    this.timer = null
    this.interval = null
  }

  // --- Private ---

  _showMessage() {
    if (this.hasDotsTarget) {
      this.dotsTarget.classList.add("hidden")
    }

    if (this.hasMessageTarget) {
      this._renderWave(this._shuffled[this._messageIndex])
      this.messageTarget.classList.remove("hidden")
      this.element.classList.remove("hidden")
      this._messageIndex++
    }

    this.interval = setInterval(() => {
      if (this.hasMessageTarget) {
        if (this._messageIndex >= this._shuffled.length) {
          this._messageIndex = 0
          this._shuffled = this._shuffleMessages()
        }
        this._renderWave(this._shuffled[this._messageIndex])
        this._messageIndex++
      }
    }, this.delayValue)
  }

  _renderWave(text) {
    const target = this.messageTarget
    target.innerHTML = ""
    target.classList.add("thinking-wave")

    let charIndex = 0
    for (const char of text) {
      const span = document.createElement("span")
      if (char === " ") {
        span.classList.add("thinking-space")
      } else {
        span.textContent = char
        span.style.animationDelay = `${charIndex * 0.05}s`
      }
      target.appendChild(span)
      charIndex++
    }
  }

  _shuffleMessages() {
    const messages = [...this.constructor.MESSAGES]
    for (let i = messages.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [messages[i], messages[j]] = [messages[j], messages[i]]
    }
    return messages
  }
}
